import { freeze, produce } from 'immer';
import { TGlobalStores } from '..';
import { getIncrementId } from '@/editor/utils';
import { EPatchType, IPatchItem } from '@/editor/types/baseStore';
import { AbstractHistoryStore } from '../../history/abstractHistoryStore';

export class BaseObjectStore<T extends object> implements AbstractHistoryStore {
  public id: number;
  private _obj: T;
  private _history;

  constructor(gs: TGlobalStores, initialData: T) {
    this._history = gs.history;

    this._obj = freeze(initialData);
    this.id = getIncrementId();
    this._history.addStore(this);
  }

  update(data: Partial<T>) {
    if (!data) return;

    // 记录反转操作
    const invertData: Partial<T> = {};
    Object.keys(data).forEach((key) => {
      invertData[key as keyof T] = this._obj[key as keyof T];
    });

    // 更新对象
    this._obj = produce(this._obj, (draft) => {
      // immer 的 Draft<T> 在泛型下把 Promise 并进了类型，这里并非异步
      void Object.assign(draft, data);
    });

    this.recordChange({
      sId: this.id,
      type: EPatchType.ObjectUpdate,
      data: invertData
    });
  }

  get(key: keyof T) {
    return this._obj[key];
  }

  recordChange(change: IPatchItem<T>) {
    this._history.recordDataChange(change);
  }

  applyChange(change: IPatchItem<T>) {
    switch (change.type) {
      case EPatchType.ObjectUpdate:
        this.update(change.data);
        break;
    }
  }
}
